import type { FC } from "react";
import { motion } from "motion/react";

import { mergeClasses } from "@huub-web/utils";

import { contentChildMotionVariants } from "../ChatHistoryList.motion";
import { focusVisible } from "../../../theme/css/focusVisible.css";
import { Text } from "../../Text/Text";
import { chatStyle } from "./HistoryChat.css";

export const HistoryChat: FC<{
  title: string;
  active: boolean;
  onClick: () => void;
}> = ({ title, active = false, onClick }) => (
  <motion.li variants={contentChildMotionVariants}>
    <button
      type="button"
      className={mergeClasses(chatStyle({ active }), focusVisible)}
      onClick={onClick}
    >
      <Text as="span" variant="bodyS" ellipsis>
        {title}
      </Text>
    </button>
  </motion.li>
);
